import React from "react"
import { Card } from "react-bootstrap"
import ColoredLine from "../components/ColoredLine"

export default function ({ name, url, description, language }) {
  return (
    <div>
      <Card style={{ width: "18rem", border: 0 }}>
        <Card.Body
          style={{
            backgroundColor: "#aaaaaa",
          }}
        >
          <Card.Title
            style={{
              fontWeight: "bold",
            }}
          >
            {name}
          </Card.Title>
          <Card.Subtitle className="mb-2 text-muted">{language}</Card.Subtitle>
          <Card.Text
            style={{
              fontStyle: "italic",
            }}
          >
            {description}
          </Card.Text>

          <Card.Link href={url} target="__blank">
            Learn More
          </Card.Link>
          <ColoredLine lineColor="black" />
        </Card.Body>
      </Card>
    </div>
  )
}
